export default __webpack_public_path__ + "static/media/flag-ireland.80390c28.svg";